const { SITE_NAME, BRAND_NAME } = process.env;

export default ({ service, providers, city }) => {
	if (!providers || !service) return [];
	const response = [
		{
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
			"itemListElement": [
				{
					"@type": "ListItem",
					"position": 1,
					"item": {
						"@id": `https://${SITE_NAME}.com/`,
						"name": BRAND_NAME,
						"url": `https://${SITE_NAME}.com/`,
					},
				},
				{
					"@type": "ListItem",
					"position": 2,
					"item": {
						"@id": `https://${SITE_NAME}.com/${city.state.toLowerCase()}/`,
						"name": city.state.toUpperCase(),
						"url": `https://${SITE_NAME}.com/${city.state.toLowerCase()}/`,
					},
				},
				{
					"@type": "ListItem",
					"position": 3,
					"item": {
						"@id": `https://${SITE_NAME}.com/${city.state.toLowerCase()}/${city.name
							.toLowerCase()
							.replace(/ /g, "-")}/`,
						"name": `${city.name.ucFirst()}`,
						"url": `https://${SITE_NAME}.com/${city.state.toLowerCase()}/${city.name
							.toLowerCase()
							.replace(/ /g, "-")}/`,
					},
				},
				{
					"@type": "ListItem",
					"position": 4,
					"item": {
						"@id": `https://${SITE_NAME}.com/${city.state.toLowerCase()}/${city.name
							.toLowerCase()
							.replace(/ /g, "-")}${service.url}/`,
						"name": `${(service.phrase
							? service.phrase
							: service.name
						).ucFirst()}`,
						"url": `https://${SITE_NAME}.com/${city.state.toLowerCase()}/${city.name
							.toLowerCase()
							.replace(/ /g, "-")}${service.url}/`,
					},
				},
			],
		},
	];

	const itemLists = providers.map((provider, index) => {
		const item = {
			// "@context": "https://schema.org",
			"@type": "LocalBusiness",
			"address": {
				"@type": "PostalAddress",
				"addressLocality": `${provider.location.city.ucFirst()}`,
				"addressRegion": `${provider.location.state.toUpperCase()}`,
				"postalCode": `${provider.location.zip}`,
			},
			"name": `${provider.company_name.ucFirst()}`,
			"image": `${provider.image.value}`,
			//TODO ADD PRICE RANGE IF SET & SAMEAS = ANY SOCIAL LINKS SET
			//"priceRange": "",
			// "sameAs": [
			//     "facebook...",
			//     "twitter...",
			//     "etc...",
			// ],
			//"openingHours": "Mo,Tu,We,Th 09:00-12:00",
			//"paymentAccepted":"Cash, Credit Card, Bitcoin",
			//"numberOfEmployees": 3,
			"url": `https://${SITE_NAME}.com/${provider.profile.url}`,
		};
		if (provider.company_employees) {
			item["numberOfEmployees"] = provider.company_employees;
		}

		if (provider.social) {
			item["sameAs"] = Object.values(provider.social);
		}

		if (provider.accepted_payment_types) {
			item["paymentAccepted"] = provider.accepted_payment_types.join(", ");
		}
		if (provider.metrics.reviews_count === 0)
			return {
				"@type": "ListItem",
				"position": index + 1,
				"item": item,
			};

		item["aggregateRating"] = {
			"@type": "AggregateRating",
			"ratingValue": `${provider.metrics.reviews_avg.toFixed(2)}`,
			"reviewCount": `${provider.metrics.reviews_count}`,
			"bestRating": `${provider.best_review?.rating?.toFixed(0) || 0}`,
			"worstRating": `${provider.worst_review?.rating?.toFixed(0) || 5}`,
		};

		// item["review"] = (provider.reviews || []).map((review) => {
		// 	const published = new Date(review.created_at);
		// 	const publishedYear = published.getFullYear();
		// 	const publishedMonth =
		// 		published.getMonth() + 1 > 9
		// 			? published.getMonth() + 1
		// 			: "0" + (published.getMonth() + 1);
		// 	const publishedDay =
		// 		published.getDate() > 9 ? published.getDate() : "0" + published.getDate();
		// 	const authorName = review.author;

		// 	return [
		// 		{
		// 			"@type": "Review",
		// 			"datePublished": `${publishedYear}-${publishedMonth}-${publishedDay}`,
		// 			"description": `${review.message.body
		// 				.replace(/"/g, "")
		// 				.replace(/'/g, "")}`,
		// 			"author": {
		// 				"@type": "Person",
		// 				"name": `${authorName}`,
		// 			},
		// 			"reviewRating": {
		// 				"@type": "Rating",
		// 				"ratingValue": `${review.rating}`,
		// 			},
		// 		},
		// 	];
		// });
		return {
			"@type": "ListItem",
			"position": index + 1,
			"item": item,
		};
	});
	return response.concat({
		"@context": "https://schema.org",
		"@type": "ItemList",
		"itemListElement": itemLists,
	});
};
